<template>
  <div class="wx-pay-overlay">
    <template v-if="isTestPay">
      <native-pay
        v-model="isShow"
        :qrcode="qrcode"
        @click="paySuccess"
      />
    </template>
    <template v-else>
      <h5-pay
        v-model="isShow"
        @success="paySuccess"
      />
    </template>
  </div>
</template>

<script>
import H5Pay from './WxPaySuccessOverlay'
import NativePay from './WxQrcodeOverlay'
import { wxPayENV } from '@/config/wx.config'

export default {
  name: 'WxPayOverlay',
  components: { H5Pay, NativePay },
  props: {
    overlayStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    qrcode: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isTestPay: false
  }),
  computed: {
    isShow: {
      get () {
        return this.overlayStatus
      },
      set (status) {
        this.$emit('update:overlayStatus', status)
      }
    }
  },
  mounted () {
    this.isTestPay = wxPayENV === 'NATIVE'
  },
  methods: {
    paySuccess () {
      this.$emit('successed')
    }
  }
}
</script>

<style scoped lang="scss">
.wx-pay-overlay {}
</style>
